import { render, staticRenderFns } from "./myBankCard.vue?vue&type=template&id=44a475e2&scoped=true&"
import script from "./myBankCard.vue?vue&type=script&lang=js&"
export * from "./myBankCard.vue?vue&type=script&lang=js&"
import style0 from "./myBankCard.vue?vue&type=style&index=0&id=44a475e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a475e2",
  null
  
)

export default component.exports